// Informations sur le format des dates.
export const MY_FORMATS_DATE = {
    parse: {
        dateInput: 'DD/MM/YYYY',
    },
    display: {
        dateInput: 'DD/MM/YYYY',
        monthYearLabel: 'MM YYYY',
        dateA11yLabel: 'DD/MM/YYYY',
        monthYearA11yLabel: 'MM YYYY',
    },
};

export const MY_FORMATS_DATETIME = {
    parse: {
        dateInput: 'dd/MM/YYYY HH:mm:ss',
    },
    display: {
        dateInput: 'dd/MM/YYYY HH:mm:ss',
        monthYearLabel: 'MM YYYY',
        dateA11yLabel: 'dd/MM/YYYY',
        monthYearA11yLabel: 'MM YYYY',
    },
};
